const carouselItems = [
  {
    title: '暑期档院线同步',
    desc: '最新院线大片上线7777影院，高清画质同步观看，足不出户享受影院级体验。动作、科幻、动画、悬疑各类题材全覆盖。',
    tag: '院线同步',
    img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20movie%20theater%20atmosphere%20with%20dramatic%20golden%20spotlight%2C%20red%20velvet%20curtains%2C%20grand%20cinema%20interior%2C%20warm%20amber%20and%20crimson%20lighting%2C%20luxurious%20vintage%20movie%20palace%20style%2C%20rich%20textures%20and%20dramatic%20shadows&width=900&height=500&seq=carousel-summer-2026&orientation=landscape',
  },
  {
    title: '国产剧高分合集',
    desc: '精选50部豆瓣8分以上国产好剧，从悬疑到古装、从都市到年代，每一部都经得起推敲。全集在线，一口气追完不费劲。',
    tag: '高分精选',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20historical%20drama%20scene%20with%20warm%20lantern%20lighting%2C%20traditional%20architecture%20in%20soft%20focus%20background%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20cinematic%20composition%2C%20elegant%20and%20atmospheric%2C%20period%20drama%20aesthetic&width=900&height=500&seq=carousel-drama-2026&orientation=landscape',
  },
  {
    title: '日漫七月新番',
    desc: '七月新番全线同步，热血战斗、治愈日常、悬疑推理各种题材任你选。双语字幕高清画质，追番体验全面升级。',
    tag: '新番速递',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20Japanese%20anime%20style%20cityscape%20at%20sunset%2C%20warm%20orange%20and%20pink%20sky%2C%20stylized%20urban%20buildings%2C%20dreamy%20atmospheric%20lighting%2C%20whimsical%20clouds%2C%20animation%20background%20art%20style%2C%20cinematic%20composition&width=900&height=500&seq=carousel-anime-2026&orientation=landscape',
  },
  {
    title: '经典老片修复',
    desc: '多部影史经典4K修复版上线，从黑白电影到黄金年代港片，画质焕新情怀不变。重温那些感动过我们的银幕记忆。',
    tag: '经典修复',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20beam%2C%20old%20cinema%20equipment%20on%20dark%20wooden%20table%2C%20nostalgic%20atmosphere%2C%20celluloid%20film%20reels%2C%20warm%20sepia%20and%20amber%20tones%2C%20retro%20cinema%20aesthetic%2C%20dramatic%20lighting&width=900&height=500&seq=carousel-classic-2026&orientation=landscape',
  },
  {
    title: '纪录片神作合集',
    desc: 'BBC、国家地理等顶级纪录片制作团队出品，从自然奇观到人文历史，用镜头语言讲述真实世界的动人故事。',
    tag: '纪录大片',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20vast%20natural%20wilderness%2C%20dramatic%20golden%20sunset%20lighting%20over%20mountain%20range%2C%20epic%20scale%20documentary%20cinematography%2C%20warm%20amber%20and%20deep%20green%20color%20palette%2C%20breathtaking%20vista%2C%20serene%20atmosphere&width=900&height=500&seq=carousel-docu-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            热门专题
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            精心策划的影视专题，发现你的下一部最爱
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.slice(0, 3).map((item, i) => (
            <div
              key={i}
              className="group relative bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer hover:border-primary-300 transition-all"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="450"
                  height="253"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-lg font-semibold text-white mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-white/80 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}

          {carouselItems.slice(3, 5).map((item, i) => (
            <div
              key={i + 3}
              className={`group relative bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer hover:border-primary-300 transition-all ${
                i === 1 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  width="450"
                  height="253"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="text-lg font-semibold text-white mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-sm text-white/80 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}